import React from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";

const items = [
  {
    quote:
      "We plugged Digimonk into our WhatsApp and stopped losing leads overnight. Our reps now only speak to people who are ready to buy.",
    name: "Priya Nair",
    role: "Head of Growth, UrbanNest Realty",
    metric: "3.2x more booked demos",
  },
  {
    quote:
      "The AI qualifies leads better than half our junior team did, and it never sleeps. ROI was obvious in the first two weeks.",
    name: "Daniel Okafor",
    role: "Founder, LedgerLoop",
    metric: "68% less telecaller cost",
  },
  {
    quote:
      "Every qualified lead lands in our sheet and CRM instantly. Zero manual data entry, zero leads slipping through.",
    name: "Meera Shah",
    role: "Sales Director, BrightSmile Clinics",
    metric: "under 5s response time",
  },
];

export const Testimonials = () => (
  <section className="bg-silver-100/70 py-28 sm:py-32" data-testid="testimonials">
    <div className="mx-auto max-w-6xl px-5">
      <div className="mb-14 max-w-2xl">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand">Proof</span>
        <h2 className="mt-4 font-display text-4xl font-black tracking-tighter text-charcoal sm:text-5xl">
          Teams that stopped chasing and started closing.
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {items.map((t, i) => (
          <motion.figure
            key={t.name}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            className="flex flex-col rounded-3xl border border-silver-300/60 bg-white p-8"
          >
            <div className="mb-4 flex gap-0.5">
              {[...Array(5)].map((_, k) => (
                <Star key={k} className="h-4 w-4 fill-brand text-brand" />
              ))}
            </div>
            <blockquote className="flex-1 text-base leading-relaxed text-charcoal">{`“${t.quote}”`}</blockquote>
            <div className="mt-6 inline-flex w-fit rounded-full bg-brand-light px-3 py-1 text-xs font-bold text-brand-dark">
              {t.metric}
            </div>
            <figcaption className="mt-5 flex items-center gap-3 border-t border-silver-300/60 pt-5">
              <span className="h-10 w-10 rounded-full bg-gradient-to-br from-silver-300 to-silver-500" />
              <div>
                <p className="text-sm font-bold text-charcoal">{t.name}</p>
                <p className="text-xs text-silver-500">{t.role}</p>
              </div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
